"use strict";

require("core-js/modules/es6.array.map");

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var Action = function Action() {
  var _this = this;

  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      type = _ref.type,
      _ref$payload = _ref.payload,
      payload = _ref$payload === void 0 ? this.payload : _ref$payload,
      keyPath = _ref.keyPath,
      steps = _ref.steps;

  (0, _classCallCheck2["default"])(this, Action);
  (0, _defineProperty2["default"])(this, "type", "");
  (0, _defineProperty2["default"])(this, "payload", void 0);
  (0, _defineProperty2["default"])(this, "keyPath", []);
  (0, _defineProperty2["default"])(this, "steps", []);
  (0, _defineProperty2["default"])(this, "_addStep", function (step) {
    return new Action({
      type: _this.type,
      payload: _this.payload,
      steps: [step].concat((0, _toConsumableArray2["default"])(_this.steps)),
      keyPath: step.type === 'get' // $FlowFixMe - I'll make sure that step.key is defined when type is 'get'
      ? [step.key].concat((0, _toConsumableArray2["default"])(_this.keyPath)) : _this.keyPath
    });
  });
  this.type = type || this.type;
  this.payload = payload;
  this.keyPath = keyPath || this.keyPath;

  if (!steps) {
    steps = keyPath ? keyPath.map(function (key) {
      return {
        type: 'get',
        key: key
      };
    }) : this.steps;
  }

  this.steps = steps;
};

exports["default"] = Action;